module.exports = __webpack_public_path__ + "static/media/hero-bg.e6794b4c.png";